import {
  BRAND_ORDERS_OFFSET,
  BRAND_ORDERS_COUNT,
  BRAND_ORDERS_PER_PAGE,
  BRAND_ORDERS_ORDER,
  BRAND_ORDERS_FILTERS,
  BRAND_ORDERS_FILTER_DATA,
  BRAND_ORDERS_ORDER_LOADING,
  BRAND_ORDERS_SEARCH,
  BRAND_ORDERS_SORT,
  BRAND_ORDERS_STATUS_COUNT,
} from '../constants/brandOrdersTypes';
import { retailers } from '../../constants/filters';

export const BrandOrdersActions = {
  loading: '[brandOrders] loading',
  modals: '[brandOrders] modals',
  downloadDocuments: '[brandOrders] downloadDocuments',
};

export const countsDisplays = {
  all: 'ALL',
  processing: 'PROCESSING',
  completed: 'COMPLETED',
  canceled: 'CANCELED',
};

const initialState = {
  data: [],
  offset: 0,
  perPage: 10,
  search: '',
  statusCount: 0,
  order: {},
  field: 'created_at',
  sort: 'desc',
  counts: {
    all: 0,
    processing: 0,
    completed: 0,
    canceled: 0,
    active: 'all',
  },
  loading: {
    orders: false,
    filters: false,
    downloadDocuments: false,
  },
  modals: {
    currency: false,
    report: false,
  },
  orderLoading: true,
  retailers: retailers,
  downloadOrderDocuments: null,
};

const brandOrders = (state = initialState, action) => {
  switch (action.type) {
    case BRAND_ORDERS_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case BRAND_ORDERS_COUNT:
      return {
        ...state,
        counts: {
          ...state.counts,
          all: Number(action.payload.all),
        },
      };
    case BRAND_ORDERS_STATUS_COUNT:
      return {
        ...state,
        statusCount: +action.payload,
      };
    case BRAND_ORDERS_PER_PAGE:
      return {
        ...state,
        perPage: +action.payload,
      };
    case BRAND_ORDERS_FILTERS: {
      return {
        ...state,
        counts: {
          ...state.counts,
          completed: action.payload.orders_per_status.completed,
          canceled: action.payload.orders_per_status.canceled,
          processing: action.payload.orders_per_status.pending,
        },
        retailers: action.payload.orders_per_retailer ? action.payload.orders_per_retailer : state.retailers,
      };
    }
    case BRAND_ORDERS_SEARCH:
      return {
        ...state,
        search: action.payload,
        offset: 0,
      };
    case BRAND_ORDERS_FILTER_DATA:
      return {
        ...state,
        data: action.payload.data,
        counts: {
          ...state.counts,
          active: action.payload.title,
        },
      };
    case BRAND_ORDERS_ORDER:
      return {
        ...state,
        order: action.payload,
        orderLoading: false,
      };
    case BRAND_ORDERS_ORDER_LOADING:
      return {
        ...state,
        orderLoading: action.payload,
      };
    case BRAND_ORDERS_SORT:
      const { order, field } = action.payload;

      return {
        ...state,
        sort: order,
        field,
      };
    case BrandOrdersActions.downloadDocuments:
      return {
        ...state,
        downloadOrderDocuments: action.payload,
        loading: {
          ...state.loading,
          downloadDocuments: !!action.payload,
        },
      };

    case BrandOrdersActions.loading:
      return {
        ...state,
        loading: {
          ...state.loading,
          ...action.payload,
        },
      };

    case BrandOrdersActions.modals:
      return {
        ...state,
        modals: {
          ...state.modals,
          ...action.payload,
        },
      };

    default:
      break;
  }

  return state;
};

export default brandOrders;
